"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JavascriptResponse = exports.CONTEXT_RESPONSE_HEADERS = void 0;
const client_1 = require("./client");
/**
 * Standard headers for user-specific JavaScript context responses.
 * These headers prevent caching of personalized data that could leak between users.
 */
exports.CONTEXT_RESPONSE_HEADERS = {
    'Content-Type': 'application/javascript; charset=UTF-8',
    'Cache-Control': 'private, no-store, no-cache, must-revalidate',
    Vary: 'Cookie',
};
class JavascriptResponse {
    constructor() {
        this.javascriptStatements = [];
    }
    addLine(stringCode) {
        this.javascriptStatements.push(stringCode);
    }
    logMessage(message) {
        this.addLine(`console.log("${message.replaceAll('"', '\\"')}");`);
    }
    logError(message) {
        this.addLine(`console.error("${message.replaceAll('"', '\\"')}");`);
    }
    redirectToHome() {
        this.addLine(`const url = new URL(window.location.origin);`);
        this.addLine(`url.searchParams.set('next', window.location.pathname);`);
        this.addLine(`window.location.assign(url);`);
    }
    assignAppContext(appContextData) {
        this.addLine(`window.${client_1.APP_CONTEXT_VAR_NAME} = ${JSON.stringify(appContextData)}`);
    }
    flush() {
        const javascriptString = this.javascriptStatements.join('\n');
        this.javascriptStatements = [];
        return javascriptString;
    }
    /**
     * Creates a Response object with proper cache-control headers for App Router.
     * Use this method instead of manually creating a Response to ensure
     * user-specific context data is never cached.
     *
     * @param status - HTTP status code (default: 200)
     * @returns Response object with proper headers
     *
     * @example
     * ```typescript
     * // In App Router API route
     * const javascriptResponse = new JavascriptResponse();
     * javascriptResponse.assignAppContext(appContextData);
     * return javascriptResponse.toResponse();
     * ```
     */
    toResponse(status = 200) {
        return new Response(this.flush(), {
            status,
            headers: exports.CONTEXT_RESPONSE_HEADERS,
        });
    }
    /**
     * Sends the response with proper cache-control headers for Pages Router.
     * Use this method instead of manually setting headers to ensure
     * user-specific context data is never cached.
     *
     * @param res - NextApiResponse object
     * @param status - HTTP status code (default: 200)
     *
     * @example
     * ```typescript
     * // In Pages Router API route
     * const javascriptResponse = new JavascriptResponse();
     * javascriptResponse.assignAppContext(appContextData);
     * javascriptResponse.sendResponse(res);
     * ```
     */
    sendResponse(res, status = 200) {
        Object.entries(exports.CONTEXT_RESPONSE_HEADERS).forEach(([key, value]) => {
            res.setHeader(key, value);
        });
        res.status(status).send(this.flush());
    }
}
exports.JavascriptResponse = JavascriptResponse;
//# sourceMappingURL=javascript-response.js.map